<div class="con_box">
  <div class="header">
    <p class="title">In Progress</p>
    <div class="cancle">
      <ion-button class="cancle_btn" fill="clear"  size="small" (click)="cancle()">Cancel</ion-button>
      <ion-button class="save_btn" fill="clear" size="small" (click)="save()">save</ion-button>
    </div>
  </div>

<form [formGroup]='inprocess_form'>

  <div class="input-item">
    <ion-label color="grey" class="input__title" position="stacked">Ship Date </ion-label>
    <div lines="none" class="custom-input" [class.focused]="focus.ship_date"> 
      <ion-input name="ship_date" [min]='today_date'  type="date" (ionFocus)="focus.ship_date = true" (ionBlur)="focus.ship_date = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="ship_date" ></ion-input>
    </div>
    <div *ngIf="submitted && !ship_date?.valid"> 
      <p class="err m-0" *ngIf="ship_date.errors.required">Ship Date  is required</p> 
    </div>
  </div>

  <div class="input-item">
    <ion-label color="grey" class="input__title" position="stacked">Delivery Date </ion-label>
    <div lines="none" class="custom-input" [class.focused]="focus.delivery_date"> 
      <ion-input name="ship_date" [min]='today_date' type="date" (ionFocus)="focus.delivery_date = true" (ionBlur)="focus.delivery_date = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="delivery_date" ></ion-input>
    </div>
    <div *ngIf="submitted && !delivery_date?.valid"> 
      <p class="err m-0" *ngIf="delivery_date.errors.required">Delivery Date is required</p> 
    </div>
  </div>

  <p class="err m-0" *ngIf="error_msg">{{status}}</p> 

</form>

</div>